export default "__VITE_ASSET__BE6DdCOa__"